export default {
  data() {
    return {
      idleTimer: null,
      idleTime: 30000, // 30秒
      refreshTimer: null,
      refreshTime: 30 * 60 * 1000 // 30分钟
    }
  },
  mounted() {
    console.log('idle-mounted')
    this.setupIdleDetection();
  },
  beforeDestroy() {
    this.removeIdleDetection();
  },
  methods: {
    setupIdleDetection() {
      // 重置计时器
      this.resetIdleTimer();

      // 添加事件监听
      document.addEventListener('click', this.resetIdleTimer);
      document.addEventListener('touchstart', this.resetIdleTimer);
      document.addEventListener('keydown', this.resetIdleTimer);
      document.addEventListener('mousemove', this.resetIdleTimer);
    },

    removeIdleDetection() {
      // 清除计时器
      if (this.idleTimer) {
        clearTimeout(this.idleTimer);
      }
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
      }

      // 移除事件监听
      document.removeEventListener('click', this.resetIdleTimer);
      document.removeEventListener('touchstart', this.resetIdleTimer);
      document.removeEventListener('keydown', this.resetIdleTimer);
      document.removeEventListener('mousemove', this.resetIdleTimer);
    },

    resetIdleTimer() {
      // 如果用户未登录，不重置计时器
      if (!this.$store.state.app.token) {
        return;
      }

      // 清除之前的计时器
      if (this.idleTimer) {
        clearTimeout(this.idleTimer);
      }
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
      }

      // 设置30秒计时器 - 显示欢迎页面
      this.idleTimer = setTimeout(() => {
        console.log('30秒无操作，显示欢迎页面')
        // 30秒无操作，显示欢迎页面（组件方式，保留页面数据）
        this.$store.commit('SHOW_WELCOME');
      }, this.idleTime);

      // 设置30分钟计时器 - 刷新页面
      this.refreshTimer = setTimeout(() => {
        console.log('30分钟无操作，刷新页面重新加载')
        // 30分钟无操作，刷新页面并跳转到首页
        sessionStorage.setItem('idle_timeout', 'true');
        window.location.href = '/';
        window.location.reload();
      }, this.refreshTime);
    }
  }
}
